var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vs-dropdown',{attrs:{"border":true}},[_c('div',{staticClass:"flex items-center"},[_vm._t("btn"),_c('feather-icon',{attrs:{"svgClasses":"h-4 w-4","icon":"InfoIcon"}})],2),_c('vs-dropdown-menu',[_vm._t("content")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }